import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useCamp = () => {
  const [camp, setCamp] = useState(null);
  useEffect(() => {
    axios.get(`${API}/camps/current`).then((r) => setCamp(r.data)).catch(() => setCamp(null));
  }, []);
  return camp;
};
